import React from "react";
import PropTypes from "prop-types";
const CropIcon = ({
  noPointer,
  className,
  width,
  size,
  height,
  style,
  color,
  title
}) => (
  <svg
    className={className}
    style={style}
    data-no-pointer={noPointer}
    width={width || size || 24}
    height={height || size || 24}
    viewBox="2 2 16 16"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby="title"
    data-testid="cropIcon"
  >
    <title>{title}</title>
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h20v20H0z" />
      <path d="M2 2h16v16H2z" />
      <g fill={color || "var(--color-easil-gray-x-dark)"} fillRule="nonzero">
        <path d="M17 13a1 1 0 0 1 0 2H7a2 2 0 0 1-2-2V3a1 1 0 1 1 2 0v10h10z" />
        <path d="M14 17a1 1 0 0 0 2 0v-2.063a1 1 0 0 0-2 0V17zm0-6.958a1 1 0 0 0 2 0V6a2 2 0 0 0-2-2h-3.944a1 1 0 0 0 0 2H14v4.042zM5.204 6a1 1 0 1 0 0-2H3a1 1 0 1 0 0 2h2.204z" />
      </g>
    </g>
  </svg>
);
CropIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  size: PropTypes.string,
  height: PropTypes.string,
  style: PropTypes.object,
  color: PropTypes.string
};

export default CropIcon;
